import { ENV_VARIABLES } from "../Config/env-config";

export const clientNameConfig = {
  SN: ENV_VARIABLES.REACT_APP_CLIENT_NAME_SN,
  R2C: ENV_VARIABLES.REACT_APP_CLIENT_NAME_R2C,
};